import { ThunkAction } from "redux-thunk";
import { Dispatch, ActionCreator } from "redux"

import { RootState} from "../store/store";
import {reportDetailType} from "../constanst/index";
import {ReportDetails, Error} from "../types/reportDetailsType";
import {reportDetailsAction} from "./IReportDetailsAction"
import {Exception} from "../types/exceptionType"; 

import axiosInstance from "../utils/axiosInstance";

export const fetchReportDetailsRequest = ()=>{
    return{
        type:reportDetailType.FETCH_REPORTDETAILD_REQUEST
    }
}

export const fetchReportDetailsSuccess = (data:ReportDetails)=>{
    return{
        type:reportDetailType.FETCH_REPORTDETAIL_SUCCESS,
        payload:data
    }
}

export const fetchReportDetailsFailure = (error:Error)=>{
    return{
        type:reportDetailType.FETCH_REPORTDETAIL_FAILURE,
        payload:error
    }
}

export const cleanReportDetails = () =>{
  return{
    type:reportDetailType.CLEAN_REPORTDETAIL
  }
}


export const fetchReportDetails:ActionCreator<ThunkAction<void, RootState, null, reportDetailsAction>> = (reportId:any) => {
  return(dispatch:Dispatch)=>{
        dispatch(fetchReportDetailsRequest());
    axiosInstance
      .get(`/resources/${reportId}`)
      .then((response:any) => {
        const data:ReportDetails = response.data.data;
        dispatch(fetchReportDetailsSuccess(data));
      })
      .catch((error:any) => {
        const data:Exception= {status:error.response.status, message:error?.response?.message || "", data:error.response?.data?.data || {}}
        dispatch(fetchReportDetailsFailure(data));
      });
    }
}

export const cleanUpReport =()=>{
  return(dispatch:Dispatch)=>{
    dispatch(cleanReportDetails());
  }
}